import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const removeDuplicatedFromCart = () => axios.get(`${API_URLS.CART}remove-duplicated`);
